import React from 'react';
import { ErrorModal } from '../modals/ErrorModal';

export const handleResponseFailure = (responseStatus: number) => {
    if (responseStatus === 429) {
        return (
            <ErrorModal
                title="You've reached the limit"
                subtitle="Your usage limit has been exhausted. Please check back later to continue."
                buttonText="Close"
            />
        );
    }

    return (
        <ErrorModal
            title="Something went wrong"
            subtitle="We couldn't generate your brief this time. Try tweaking your prompt and give it another shot."
            buttonText="Back"
        />
    );
};
